import PracticePage from "@/components/PracticePage";
import CTABanner from "@/components/CTABanner";
import FAQ from "@/components/FAQ";
import { useSEO } from "@/lib/seo";

export default function ElderLaw() {
    useSEO({
        title: "Elder Law Attorneys | Long-Term Care, Medicaid & Special Needs",
        description:
            "Elder law counsel for Tennessee families: long-term care planning, Medicaid and VA benefits, special needs trusts, and advance directives.",
        path: "/elder-law",
        schema: {
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "Elder Law",
            provider: { "@type": "LegalService", name: "Chesterton" }
        }
    });

    return (
        <>
            <PracticePage
                slug="elder-law"
                kicker="Practice · Elder Law"
                title={<>Plan for the years when planning is hardest.</>}
                lede="Aging brings decisions no one wants to make in a hurry: who decides, who pays, and how care is delivered. We help families put the right documents and the right benefits in place before a crisis, and we help those already in one make sense of what comes next."
                heroImg="https://images.unsplash.com/photo-1711443418892-244b303a8cad?w=2000&q=80&auto=format&fit=crop"
                bullets={[
                    "Long-term care and asset-protection planning",
                    "Medicaid planning and eligibility counsel",
                    "VA Aid and Attendance benefits",
                    "Special needs trusts (first-party and third-party)",
                    "Durable and healthcare powers of attorney",
                    "Advance directives and HIPAA authorizations",
                    "Guardianships and conservatorships (uncontested)",
                    "Elder financial exploitation prevention"
                ]}
                sections={[
                    {
                        h: "Long-term care planning, before the crisis.",
                        p: "Nursing care in Tennessee runs well past what most families can absorb out of pocket. We map the cost of care against the assets available, and build a plan that protects what needs to be protected without running afoul of the rules that govern Medicaid eligibility later on."
                    },
                    {
                        h: "Medicaid and VA benefits, applied for correctly.",
                        p: "Both programs turn on documentation and timing. We prepare TennCare CHOICES and Nursing Facility applications, coordinate with facilities and case managers, and help qualifying veterans and surviving spouses secure Aid and Attendance and Housebound benefits."
                    },
                    {
                        h: "Special needs trusts that protect eligibility.",
                        p: "For a family member with a disability, the wrong inheritance structure can end public benefits overnight. We draft first-party and third-party special needs trusts, coordinate them with the larger estate plan, and set up trustees who understand what the trust is meant to do."
                    },
                    {
                        h: "Documents that carry the load when they need to.",
                        p: "Durable financial powers of attorney, healthcare powers, advance directives, and HIPAA waivers only work if they are current, coordinated, and drafted to match how the family actually operates. We refresh existing documents and draft new ones with the coming decade in view, not the last one."
                    }
                ]}
            />
            <FAQ />
            <CTABanner />
        </>
    );
}
